// FIXME SO-18841
import dayjs from "dayjs"
import { SoChipType } from "@/types/components/SoChip"
import { getMonthName } from "./dateHelper"

export const nextMonth = () => dayjs().add(1, "month")

export const rateChangeChipProps = {
  text: `Rates as of 1st ${getMonthName(nextMonth())}`,
  type: SoChipType.IMPORTANT,
}
